import React, { useRef, useEffect } from 'react'
import { BankModalContainer, BankWrapper, BankModalBackground } from './style'
import { MdClose } from 'react-icons/md'
import styled from 'styled-components/macro'
import { PlanAmount } from '../PlanAmount'
const ClosedModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 52px;
  height: 52px;
  padding: 0;
  z-index: 10;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 30px;
    height: 52px;
  }
`

const TargetAmountModal = ({ showModal, setShowModal }: any) => {
  const componentRef = useRef<HTMLDivElement>(null)

  const closeModal = (e: any) => {
    if (componentRef.current !== e.target) {
      setShowModal(false)
    }
  }

  return (
    <BankModalContainer>
      {showModal ? (
        <BankModalBackground>
          <BankWrapper>
            <ClosedModalButton onClick={() => setShowModal(false)} />
            <PlanAmount />
          </BankWrapper>
        </BankModalBackground>
      ) : null}
    </BankModalContainer>
  )
}

export { TargetAmountModal }
